export default __webpack_public_path__ + "static/media/member photo.22c0855c.png";